const hexColors = [
  '#7714D0',
  '#7BCBC4',
  '#EE30AC',
  '#6B66F8',
  '#FFA10D',
  '#F22613',
  '#3FC380',
  '#F3E80C',
  '#545454',
  '#3498DB',
  '#000000',
  '#1F3A93',
];

export default hexColors;
